import { render } from "./base-textbox-mobile-number.vue?vue&type=template&id=33eb548a&ts=true"
import script from "./base-textbox-mobile-number.vue?vue&type=script&lang=ts"
export * from "./base-textbox-mobile-number.vue?vue&type=script&lang=ts"

import "./base-textbox-mobile-number.vue?vue&type=style&index=0&id=33eb548a&lang=scss"

import exportComponent from "/srv/loq/temp/Admin-Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__